<template>
  <div>
    <div>
      <div v-for="file in value" :key="'file-' + file.id">
        <a :href="file.url" target="_blank" class="btn btn-block btn-orange">{{file.name}}</a>
      </div>
    </div>
    <div class="mt-2">
      <b-form-file v-model="newFile"></b-form-file>
      <loading-button variant="primary" block :loading="loading" class="mt-2" :disabled="!newFile" @submit="uploadFile" v-show="newFile">
        <font-awesome-icon icon="cloud-upload-alt"></font-awesome-icon>
        Upload
      </loading-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseBuilderFile',
  data () {
    return {
      newFile: null,
      loading: false
    };
  },
  methods: {
    uploadFile () {
      this.loading = true;
      let formData = new FormData();
      if (!Array.isArray(this.newFile))
        this.newFile = Array(this.newFile); // convert to array if single file

      this.newFile.forEach((file, idx) => formData.append(`file${idx}`, file));

      this.axios.post('/components/' + this.component_id + '/upload/file', formData).then(rsp => {
        this.$emit('input', [rsp.data]);
        this.loading = false;
        this.newFile = null;
        this.$snotify.success('File Uploaded');
      }).catch(err => this.$errorOut(err));
    }
  },
  props: ['value', 'component_id']
};
</script>

<style scoped>

</style>